// extracted by mini-css-extract-plugin
export var aniSpin = "RelatedProjects-module--ani-spin--yCw6r";
export var column = "RelatedProjects-module--column--p1jc5";
export var container = "RelatedProjects-module--container--34Lz3";
export var heading = "RelatedProjects-module--heading--iD3Mz";